export function cataloguePriceOrCurrent(cataloguePrice, currentPrice) {
  const price = Number(cataloguePrice);
  return Number.isFinite(price) && price > 0 ? price : currentPrice;
}
